module.exports = __webpack_public_path__ + "img/criteriacheck.2bea6452.svg";